var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.761,
    cy: 30.0734,
    rx: 30.4367,
    ry: 30.0339,
    fill: "#920583",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 40C25.8174 40 22.7652 38.7357 20.5147 36.4853C18.2643 34.2348 17 31.1826 17 28C17 24.8174 18.2643 21.7652 20.5147 19.5147C22.7652 17.2643 25.8174 16 29 16V40ZM32.826 18.764C34.0381 19.2676 35.1396 20.0041 36.068 20.932L37.48 19.52C36.3661 18.4065 35.0444 17.5225 33.59 16.918L32.826 18.764ZM41 28C41.0004 26.4245 40.6888 24.8644 40.083 23.41L38.236 24.174C38.7408 25.3864 39.0005 26.6867 39 28H41ZM45 38C45 36.8133 44.6481 35.6533 43.9888 34.6666C43.3295 33.6799 42.3925 32.9108 41.2961 32.4567C40.1997 32.0026 38.9933 31.8838 37.8295 32.1153C36.6656 32.3468 35.5965 32.9182 34.7574 33.7574C33.9182 34.5965 33.3468 35.6656 33.1153 36.8295C32.8838 37.9933 33.0026 39.1997 33.4567 40.2961C33.9108 41.3925 34.6799 42.3295 35.6666 42.9888C36.6533 43.6481 37.8133 44 39 44C40.5907 43.9981 42.1158 43.3654 43.2406 42.2406C44.3654 41.1158 44.9981 39.5907 45 38ZM43 38C42.9963 38.7118 42.8004 39.4093 42.433 40.019L36.981 34.567C37.5907 34.1997 38.2882 34.0038 39 34C40.0605 34.0013 41.0771 34.4232 41.827 35.173C42.5768 35.9229 42.9987 36.9395 43 38ZM35 38C35.0037 37.2882 35.1996 36.5907 35.567 35.981L41.019 41.433C40.4093 41.8003 39.7118 41.9962 39 42C37.9395 41.9987 36.9229 41.5768 36.173 40.827C35.4232 40.0771 35.0013 39.0605 35 38Z",
    fill: "#920583"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteIcon);
export default __webpack_public_path__ + "static/media/IncompleteIcon.dbe2fa1b118effd0c4652d41d1a2577a.svg";
export { ForwardRef as ReactComponent };